import React, {
  createContext,
  useContext,
  useMemo
} from 'react';
import { useBoolState } from 'common/hooks';

import {
  ModalContext as Context
} from './types';

const ModalContext = createContext({} as Context);
export const useModalContext = () => useContext(ModalContext);

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [ showContent, handleToggleContent,, handleHideContent ] = useBoolState(true);

  const value = useMemo(() => ({
    showContent,
    handleToggleContent,
    handleHideContent
  }), [
    showContent,
    handleToggleContent,
    handleHideContent
  ]);

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};

